import React, { useEffect, useContext } from "react";
import { Box, Button, Heading, Flex } from "@chakra-ui/react";
import { Formik, Form } from "formik";
import { ProductsContext } from "../Context/ProductsContext";
import CustomField from "../Common/Form/CustomField";
import { arrayToQuery } from "../../Utils/formatUtils";
const ProductsFilter = () => {
  const { brandsOptions, categoriesOptions, getProducts } =
    useContext(ProductsContext);

  useEffect(() => {
    getProducts();
  }, []);

  const handleSubmit = (values) => {
    let queries = {};
    if (values.name) queries.name = values.name;
    if (values.brand !== null) queries.brand = values.brand.value;
    if (values.categories.length)
      queries.categories = arrayToQuery(values.categories, "value");
    getProducts(queries);
  };

  return (
    <>
      <Heading variant="h2">Filtros</Heading>

      <Box>
        <Formik
          initialValues={{ name: "", categories: [], brand: null }}
          onSubmit={(values, actions) => {
            handleSubmit(values);
            actions.setSubmitting(false);
          }}
        >
          {(props) => (
            <Form>
              <Flex
                spacing="50px"
                align="left"
                flexDirection={["column", "column", "row"]}
                justifyContent="space-around"
                gap={"0.75rem"}
              >
                <Box w={["auto", "100%"]}>
                  <CustomField
                    name="name"
                    title="Buscador"
                    placeholder="Ingrese un nombre"
                    props={props}
                    customFontColor="menu.700"
                  ></CustomField>
                </Box>
                <Box w={["auto", "100%"]}>
                  <CustomField
                    name="categories"
                    title="Categorías"
                    placeholder="Elija una o mas categorías"
                    inputType="select"
                    valueLabel="name"
                    props={props}
                    multiSelect={true}
                    options={categoriesOptions}
                    customFontColor="menu.700"
                  ></CustomField>
                </Box>

                <Box w={["auto", "100%"]}>
                  <CustomField
                    name="brand"
                    title="Marcas"
                    placeholder="Elija una marca"
                    inputType="select"
                    valueLabel="name"
                    props={props}
                    options={brandsOptions}
                    customFontColor="menu.700"
                  ></CustomField>
                </Box>
                <Box align="right">
                  <Button
                    mt={4}
                    colorScheme="teal"
                    isLoading={props.isSubmitting}
                    type="submit"
                  >
                    Buscar
                  </Button>
                </Box>
              </Flex>
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
};

export default ProductsFilter;
